import React from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";

const serif = { fontFamily: "'Playfair Display', serif" };
const NAVY = "#0A2A5A";
const GOLD = "#F9AB0D";

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: NAVY }} data-testid="payment-cancel-page">
      <div className="bg-white rounded-3xl p-8 sm:p-12 max-w-md w-full text-center shadow-2xl">
        <div className="w-16 h-16 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ backgroundColor: "rgba(10,42,90,0.06)" }}>
          <Heart className="w-8 h-8" style={{ color: NAVY }} />
        </div>
        <h1 className="text-2xl mb-3" style={{ ...serif, color: NAVY }}>Checkout canceled</h1>
        <p className="text-sm text-slate-500 mb-8">
          No worries — you haven't been charged. Your plans are here whenever you're ready.
        </p>
        <button
          onClick={() => navigate("/subscription")}
          className="w-full rounded-full py-3.5 font-bold transition-transform hover:scale-[1.02]"
          style={{ backgroundColor: GOLD, color: NAVY }}
          data-testid="payment-cancel-back"
        >
          Back to Plans
        </button>
      </div>
    </div>
  );
}
